module.exports = __webpack_public_path__ + "img/logo_BOIRES.2f4314d5.png";